import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {Typography} from "@mui/material";
import Button from "@mui/material/Button";
import AppBar from "@mui/material/AppBar";
import React from "react";
import {useStylesDialog} from "../../../shared/useStyleDialog";


function ComponentFormAppBar({closeWindow, objectId}) {
    const classesDialog = useStylesDialog();

    return (
        <AppBar className={classesDialog.appBar}>
            <Toolbar>
                <IconButton
                    edge="start"
                    color="inherit"
                    onClick={() => closeWindow()}
                    aria-label="close"
                >
                    <CloseIcon />
                </IconButton>
                <Typography variant="h6" className={classesDialog.title}>
                    {objectId ? `Bauteil bearbeiten`: `Bauteil hinzufügen`}
                </Typography>
                <Button
                    type="submit"
                    color="inherit"
                >
                    Speichern
                </Button>
            </Toolbar>
        </AppBar>
    )
}
export default ComponentFormAppBar;